<template>
  <v-container
    class="wrapper-ticket-message pa-0"
    :class="{ 'ticket-dark': $vuetify.theme.isDark }"
  >
    <!-- no ticket selected + not create new ticket -->
    <v-container
      v-if="
        !isTicketSelected &&
        messages.length == 0 &&
        !isCreateNewTicket &&
        !createNewTicket
      "
      class="wrapper-view pa-0"
    >
      <div class="layer empty-state">
        <img class="empty-state__img" src="@/assets/ticket/headset-chat.png" alt="" />
        <p class="empty-state__title">{{ $t("choose a message") }}</p>
        <template v-if="!isSupportAbr">
          <p class="empty-state__subtitle">{{ $t("or create a new message") }}</p>
          <v-btn custom depressed color="#56ABFC" @click="createNewTicketHandler()">
            <span>{{ $t("new ticket") }}</span>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
      </div>
    </v-container>
    <!-- create new ticket + continuing ... -->
    <v-container class="wrapper-relative-conversation pa-0">
      <v-container
        v-if="resolveDisplay()"
        class="wrapper-conversation pa-0"
        :style="resolveWrapperHeight()"
      >
        <!--create new ticket fields-->
        <div
          v-if="
            (!isTicketSelected && messages.length == 0 && isCreateNewTicket) ||
            (!isTicketSelected && messages.length == 0 && createNewTicket)
          "
          class="wrapper-create-ticket"
        >
          <v-form ref="form" class="ticket-create-fields">
            <autocomplete
              v-model="department"
              :title="$t('departments')"
              type="departments"
              :value="department"
              :rules="[(v) => !!v || $t('is-required')]"
              class="ticket-create-field"
            />
            <v-text-field
              v-model="ticketTitle"
              :placeholder="$t('enter-ticket-title')"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || $t('is-required')]"
              class="ticket-create-field ticket-create-title-input"
              height="28"
            >
              <template v-slot:append>
                <!-- <span class="ticket-create-title-suffix">{{ $t("ticket title") }}</span> -->
              </template>
            </v-text-field>
            <div
              v-if="
                (!isTicketSelected && messages.length == 0 && isCreateNewTicket) ||
                (!isTicketSelected && messages.length == 0 && createNewTicket)
              "
            >
              <v-btn
                outlined
                dense
                height="28"
                class="ticket-create-cancel"
                @click="isDialogVisible = true"
              >
                {{ $t("ticket-decline") }}
              </v-btn>
            </div>
          </v-form>
        </div>
        <!--create new ticket title (above conversation)-->

        <!--header-->
        <v-container
          v-if="
            (isTicketSelected && messages.length > 0) ||
            (!isTicketSelected && messages.length > 0) ||
            (isTicketSelected && messages.length == 0)
          "
          class="header ticket-header-bar"
        >
          <!-- selected ticket -->
          <v-container
            v-if="
              (isTicketSelected && messages.length > 0) ||
              (isTicketSelected && messages.length == 0)
            "
            class="pa-0"
          >
            <!-- support header -->
            <div v-if="isSupportAbr" class="ticket-header-stack">
              <div class="ticket-header-info">
                <div class="ticket-header-title">
                  <span class="ticket-header-id">#{{ selectedTicket.id }}</span>
                  <span class="ticket-header-title-text">{{
                    selectedTicket.title ? selectedTicket.title : $t("new ticket")
                  }}</span>
                </div>
                <div class="ticket-header-meta">
                  <span
                    v-for="(part, i) in ticketHeaderMetaParts(selectedTicket)"
                    :key="i"
                    class="ticket-header-meta-piece"
                  >
                    <span v-if="i" class="ticket-header-meta-dot">•</span>
                    <span
                      class="ticket-header-meta-item"
                      :class="{ 'is-muted': i % 2 === 1 }"
                      >{{ part }}</span
                    >
                  </span>
                </div>
              </div>
              <div class="ticket-header-actions">
                <div class="ticket-header-status-btns">
                  <TicketPrioritySelect
                    :value="selectedPriority"
                    :disabled="isTicketClosed"
                    @input="changeTicketPriority($event, selectedTicket.id)"
                  />
                  <v-btn
                    :outlined="!isWaitingAction"
                    dense
                    height="24"
                    color="#00897b"
                    :dark="isWaitingAction"
                    :disabled="isTicketClosed || processing"
                    @click="toggleWaitingActionStatus(selectedTicket.id)"
                  >
                    {{ isWaitingAction ? $t("actionDone") : $t("inProgress") }}
                  </v-btn>
                  <v-btn
                    outlined
                    dense
                    color="error"
                    height="24"
                    :disabled="isTicketClosed"
                    @click="changeTicketStatus('closed', selectedTicket.id)"
                  >
                    {{ $t("closed") }}
                  </v-btn>
                </div>
                <div class="ticket-header-executor-fields">
                  <autocomplete
                    v-model="headerDepartment"
                    :title="$t('performingDepartment')"
                    type="departments"
                    :value="headerDepartment"
                    :disabled="isTicketClosed || processing"
                    class="ticket-header-department"
                    @input="
                      changeTicketDepartment($event, selectedTicket && selectedTicket.id)
                    "
                  />
                  <autocomplete
                    v-model="headerExecutorUser"
                    title="functor"
                    type="partners"
                    :filter="false"
                    :multiple="false"
                    :value="headerExecutorUser"
                    :disabled="isTicketClosed || processing"
                    class="ticket-header-department"
                    @input="
                      changeTicketExecutorUser($event, selectedTicket && selectedTicket.id)
                    "
                  />
                </div>
              </div>
            </div>
            <!-- normal user header -->
            <div v-else class="ticket-header-row">
              <div class="ticket-header-info">
                <div class="ticket-header-title">
                  <span class="ticket-header-id">#{{ selectedTicket.id }}</span>
                  <span class="ticket-header-title-text">{{
                    selectedTicket.title ? selectedTicket.title : $t("new ticket")
                  }}</span>
                </div>
                <div class="ticket-header-meta">
                  <span
                    v-for="(part, i) in ticketHeaderMetaParts(selectedTicket)"
                    :key="i"
                    class="ticket-header-meta-piece"
                  >
                    <span v-if="i" class="ticket-header-meta-dot">•</span>
                    <span
                      class="ticket-header-meta-item"
                      :class="{ 'is-muted': i % 2 === 1 }"
                      >{{ part }}</span
                    >
                  </span>
                </div>
              </div>
              <v-btn
                color="error"
                custom
                outlined
                class="ticket-header-close-fallback"
                @click="isDialogVisible = true"
                :disabled="isTicketClosed"
              >
                {{ isTicketClosed ? $t("closed") : $t("close ticket") }}
              </v-btn>
            </div>
          </v-container>
          <!-- not selected ticket (creating ticket)-->
          <v-container v-if="!isTicketSelected && messages.length > 0" class="pa-0">
            <!-- support header -->
            <div v-if="isSupportAbr" class="ticket-header-stack">
              <div class="ticket-header-info">
                <div class="ticket-header-title">
                  <span class="ticket-header-id"
                    >#{{ messages[messages.length - 1].ticket_id }}</span
                  >
                  <span class="ticket-header-title-text">{{
                    ticketTitle ? ticketTitle : $t("new ticket")
                  }}</span>
                </div>
                <div class="ticket-header-meta">
                  <span
                    v-for="(part, i) in ticketHeaderMetaParts(
                      messages[messages.length - 1]
                    )"
                    :key="i"
                    class="ticket-header-meta-piece"
                  >
                    <span v-if="i" class="ticket-header-meta-dot">•</span>
                    <span
                      class="ticket-header-meta-item"
                      :class="{ 'is-muted': i % 2 === 1 }"
                      >{{ part }}</span
                    >
                  </span>
                </div>
              </div>
              <div class="ticket-header-actions">
                <div class="ticket-header-status-btns">
                  <TicketPrioritySelect
                    :value="selectedPriority"
                    :disabled="isTicketClosed"
                    @input="
                      changeTicketPriority(
                        $event,
                        messages[messages.length - 1].ticket_id
                      )
                    "
                  />
                  <v-btn
                    :outlined="!isWaitingAction"
                    dense
                    height="24"
                    color="#00897b"
                    :dark="isWaitingAction"
                    :disabled="isTicketClosed || processing"
                    @click="
                      toggleWaitingActionStatus(
                        messages[messages.length - 1].ticket_id
                      )
                    "
                  >
                    {{ isWaitingAction ? $t("actionDone") : $t("inProgress") }}
                  </v-btn>
                  <v-btn
                    outlined
                    dense
                    color="error"
                    height="24"
                    :disabled="isTicketClosed"
                    @click="
                      changeTicketStatus(
                        'closed',
                        messages[messages.length - 1].ticket_id
                      )
                    "
                  >
                    {{ $t("closed") }}
                  </v-btn>
                </div>
                <div class="ticket-header-executor-fields">
                  <autocomplete
                    v-model="headerDepartment"
                    :title="$t('performingDepartment')"
                    type="departments"
                    :value="headerDepartment"
                    :disabled="isTicketClosed || processing"
                    class="ticket-header-department"
                    @input="
                      changeTicketDepartment(
                        $event,
                        messages[messages.length - 1].ticket_id
                      )
                    "
                  />
                  <autocomplete
                    v-model="headerExecutorUser"
                    title="functor"
                    type="partners"
                    :filter="false"
                    :multiple="false"
                    :value="headerExecutorUser"
                    :disabled="isTicketClosed || processing"
                    class="ticket-header-department"
                    @input="
                      changeTicketExecutorUser(
                        $event,
                        messages[messages.length - 1].ticket_id
                      )
                    "
                  />
                </div>
              </div>
            </div>
            <!-- normal user header -->
            <div v-else class="ticket-header-row">
              <div class="ticket-header-info">
                <div class="ticket-header-title">
                  <span class="ticket-header-id"
                    >#{{ messages[messages.length - 1].ticket_id }}</span
                  >
                  <span class="ticket-header-title-text">{{
                    ticketTitle ? ticketTitle : $t("new ticket")
                  }}</span>
                </div>
                <div class="ticket-header-meta">
                  <span
                    v-for="(part, i) in ticketHeaderMetaParts(
                      messages[messages.length - 1]
                    )"
                    :key="i"
                    class="ticket-header-meta-piece"
                  >
                    <span v-if="i" class="ticket-header-meta-dot">•</span>
                    <span
                      class="ticket-header-meta-item"
                      :class="{ 'is-muted': i % 2 === 1 }"
                      >{{ part }}</span
                    >
                  </span>
                </div>
              </div>
              <v-btn
                color="error"
                custom
                outlined
                class="ticket-header-close-fallback"
                :disabled="isTicketClosed"
                @click="isDialogVisible = true"
              >
                {{ isTicketClosed ? $t("closed") : $t("close ticket") }}
              </v-btn>
            </div>
          </v-container>
        </v-container>
        <!--body-->
        <v-container class="body pa-0">
          <!-- create new ticket -->
          <v-container
            class="layer pa-0"
            v-if="
              (!isTicketSelected && messages.length == 0 && isCreateNewTicket) ||
              (!isTicketSelected && messages.length == 0 && createNewTicket)
            "
          >
            <!-- <div
              class="text-center"
              style="width: 190px; height: 190px; filter: blur(1.1px)"
            >
              <img src="@/assets/ticket/.png" />
            </div> -->
            <span class="ticket-create-title">{{ $t("new ticket") }}</span>
            <v-card-text class="pa-0 text-center empty-ticket-title">{{
              $t("there is no message yet")
            }}</v-card-text>
            <v-card-text class="pa-0 mt-2 text-center empty-ticket-subtitle">{{
              $t("write your message")
            }}</v-card-text>
          </v-container>
          <!-- showing message -->
          <v-container
            class="pa-0"
            v-if="
              (!isTicketSelected && messages.length > 0) ||
              (isTicketSelected && messages.length > 0)
            "
          >
            <MessageBox
              v-if="messages != undefined && messages.length > 0"
              :messages="messages"
            />
          </v-container>
        </v-container>
        <!--footer-->
        <v-container class="footer pa-0">
          <SendMessage
            :isTicketSelected="isTicketSelected"
            :messages="messages"
            @fileAttach="fileAttach"
            @submit="submitMsgHandler"
            @checkFormValidate="checkFormValidator"
            @openTicketConversation="$emit('openTicketConversation', $event)"
            :isFormValid="isFormValid"
            :toggleSelectionTicket="toggleSelectionTicket"
            :isMessageSend="isMessageSend"
            :isTicketCanceled="isTicketCanceled"
            :isTicketStateClosed="isTicketStateClosed"
            :selectedTicket="selectedTicket"
            :stop-loading="stop_loading"
          />
        </v-container>
      </v-container>
      <!--loading messages-->
      <transition name="fade">
        <v-container class="wrapper-loading pa-0" v-if="loading && !closingTicket">
          <v-progress-circular indeterminate color="primary"> </v-progress-circular>
        </v-container>
        <v-container class="wrapper-loading pa-0" v-if="processing && closingTicket">
          <v-progress-circular indeterminate color="red"> </v-progress-circular>
          <v-card-text class="text-body-1" style="width: auto; color: red"
            >{{ $t("closing ticket") }} ...</v-card-text
          >
        </v-container>
      </transition>
    </v-container>
    <!--dialog (cancel) + (close) ticket-->
    <v-dialog v-model="isDialogVisible" max-width="400" max-height="400">
      <v-card class="px-7 py-6">
        <v-container class="d-flex justify-space-between align-center pa-0">
          <v-card-text class="text-body-2 pa-0">{{
            resolveTicketStatusTitle
          }}</v-card-text>
          <v-icon style="cursor: pointer" @click="isDialogVisible = false">
            mdi-close
          </v-icon>
        </v-container>
        <v-card-text class="text-body-1 pa-0 py-6">{{
          resolveTicketStatusText
        }}</v-card-text>
        <v-card-actions class="pa-0">
          <v-container class="pa-0 d-flex justify-center gap-2">
            <v-btn outlined class="flex-fill" @click="isDialogVisible = false">
              <span>خیر</span>
            </v-btn>
            <v-btn
              depressed
              color="error flex-fill"
              @click="pauseTicket(selectedTicket ? selectedTicket.id : null)"
            >
              <span>{{ resolveTicketStatusConfirmText }}</span>
            </v-btn>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MessageBox from "@/views/dashboard/pages/ticket/partial/message/MessageBox.vue";
import SendMessage from "@/views/dashboard/pages/ticket/partial/message/SendMessage.vue";
import TicketPrioritySelect from "@/views/dashboard/pages/ticket/partial/TicketPrioritySelect.vue";
import { resolveTicketPriority } from "@/views/dashboard/pages/ticket/ticketPriorities";

export default {
  props: {
    messages: Array,
    isTicketSelected: Boolean,
    selectedTicket: Object,
    isCreateNewTicket: Boolean,
    toggleSelectionTicket: Boolean,
    isMessageSend: Boolean,
    loading: Boolean,
    stopLoading: Boolean,
  },
  data() {
    return {
      ticketTitle: null,
      fileType: null,
      isFileAttached: false,
      createNewTicket: false,
      department: null,
      selectedDepartmentId: null,
      headerDepartment: null,
      headerExecutorUser: null,
      syncingHeaderDepartment: false,
      syncingHeaderExecutorUser: false,
      isFormValid: false,
      isDialogVisible: false,
      isTicketCanceled: false,
      isTicketStateClosed: false,
      closingTicket: false,
      processing: false,
      stop_loading: true,
      //ticketStatus
      selectedTicketStatus: null,
      selectedPriority: "normal",
    };
  },
  computed: {
    //ticketStatus
    isSupportAbr() {
      try {
        const token = JSON.parse(localStorage.getItem("token") || "{}");
        return (
          Number(
            token &&
              token.init &&
              token.init.appBarsOpacity &&
              token.init.appBarsOpacity.abr
          ) === 83
        );
      } catch (e) {
        return false;
      }
    },
    isTicketClosed() {
      if (this.isTicketStateClosed) {
        return true;
      }
      const lastMessage =
        this.messages && this.messages.length
          ? this.messages[this.messages.length - 1]
          : null;
      const state = String(
        (this.selectedTicket && this.selectedTicket.state) ||
          (lastMessage && lastMessage.state) ||
          ""
      ).toLowerCase();
      return state === "close" || state === "closed";
    },
    currentTicketState() {
      const lastMessage =
        this.messages && this.messages.length
          ? this.messages[this.messages.length - 1]
          : null;
      return String(
        (this.selectedTicket && this.selectedTicket.state) ||
          (lastMessage && lastMessage.state) ||
          ""
      ).toLowerCase();
    },
    isWaitingAction() {
      if (this.selectedTicketStatus === "waiting_action") {
        return true;
      }
      if (
        this.selectedTicketStatus === "open" ||
        this.selectedTicketStatus === "closed"
      ) {
        return false;
      }
      const state = this.currentTicketState;
      return (
        state === "waiting_action" ||
        state === "inprogress" ||
        state === "in_progress" ||
        state === "action"
      );
    },
    resolveTicketStatusTitle() {
      if (!this.isTicketSelected && this.messages.length === 0) {
        return this.$t("cancel ticket");
      } else {
        return this.$t("close ticket");
      }
    },
    resolveTicketStatusText() {
      if (!this.isTicketSelected && this.messages.length === 0) {
        return this.$t("Are you sure you want to cancel this ticket?");
      } else {
        return this.$t("Are you sure you want to close this ticket?");
      }
    },
    resolveTicketStatusConfirmText() {
      if (!this.isTicketSelected && this.messages.length === 0) {
        return this.$t("cancel the ticket");
      } else {
        return this.$t("close the ticket");
      }
    },
  },
  components: {
    MessageBox,
    SendMessage,
    TicketPrioritySelect,
  },
  methods: {
    submitMsgHandler(value) {
      this.$emit("submit", { value, ticketTitle: this.ticketTitle });
    },
    closeTicket() {
      this.$emit("closeTicket", this.messages[0].ticket_id);
    },
    ticketHeaderMetaParts(ticket) {
      if (!ticket) {
        return [];
      }
      const name = [
        ticket.user && ticket.user.firstname,
        ticket.user && ticket.user.lastname,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();
      const identity = [name || "-", ticket.customerBusinessName]
        .filter(Boolean)
        .join(" ، ");
      const department =
        (ticket.department && (ticket.department.name || ticket.department.title)) ||
        ticket.department_name ||
        (typeof ticket.department === "string" ? ticket.department : null);
      const rawTime = ticket.time ? String(ticket.time).trim() : "";
      let datePart = rawTime;
      let timePart = "";
      const timeMatch = rawTime.match(
        /^(.*)\s+([\d۰-۹]{1,2}:[\d۰-۹]{2}(?::[\d۰-۹]{2})?)$/
      );
      if (timeMatch) {
        datePart = timeMatch[1].trim();
        timePart = timeMatch[2];
      }
      return [identity, department, datePart, timePart].filter(Boolean);
    },
    changeTicketPriority(priority, ticketId) {
      if (
        !ticketId ||
        !priority ||
        this.selectedPriority === priority ||
        this.isTicketClosed
      ) {
        return;
      }
      const previous = this.selectedPriority;
      this.selectedPriority = priority;
      if (this.selectedTicket) {
        this.$set(this.selectedTicket, "priority", priority);
      }
      this.$axios
        .put(
          this.$endpoint + "ticketing/1",
          {},
          {
            params: {
              id: ticketId,
              priority,
            },
          }
        )
        .catch((e) => {
          this.selectedPriority = previous;
          if (this.selectedTicket) {
            this.$set(this.selectedTicket, "priority", previous);
          }
          this.$emit("ticketError", e);
        });
    },
    currentExecutorTicket() {
      return (
        this.selectedTicket ||
        (this.messages && this.messages.length
          ? this.messages[this.messages.length - 1]
          : null)
      );
    },
    resolveExecutorDepartment(ticket) {
      if (!ticket) {
        return null;
      }
      if (
        ticket.executor_department &&
        typeof ticket.executor_department === "object" &&
        ticket.executor_department.id != null
      ) {
        return ticket.executor_department;
      }
      const id =
        ticket.executor_department_id != null
          ? ticket.executor_department_id
          : ticket.executorDepartmentId != null
          ? ticket.executorDepartmentId
          : null;
      if (id == null) {
        return null;
      }
      const name =
        ticket.executor_department_name ||
        (typeof ticket.executor_department === "string"
          ? ticket.executor_department
          : null) ||
        "";
      return { id: id, name: name };
    },
    resolveExecutorUser(ticket) {
      if (!ticket) {
        return null;
      }
      if (
        ticket.executor_user &&
        typeof ticket.executor_user === "object" &&
        ticket.executor_user.id != null
      ) {
        return ticket.executor_user;
      }
      const id =
        ticket.executor_user_id != null
          ? ticket.executor_user_id
          : ticket.executorUserId != null
          ? ticket.executorUserId
          : null;
      if (id == null) {
        return null;
      }
      const name =
        ticket.executor_user_name ||
        (typeof ticket.executor_user === "string" ? ticket.executor_user : null) ||
        "";
      return { id: id, name: name };
    },
    buildExecutorParams(ticketId, department, user) {
      return {
        id: ticketId,
        executor_department_id:
          department && department.id != null ? Number(department.id) : null,
        executor_department:
          department && department.name ? department.name : null,
        executor_user_id: user && user.id != null ? Number(user.id) : null,
        executor_user: user && user.name ? user.name : null,
      };
    },
    applyLocalExecutorDepartment(department) {
      const nextId = department && department.id != null ? department.id : null;
      const nextName = department && department.name ? department.name : null;
      const targets = [];
      if (this.selectedTicket) {
        targets.push(this.selectedTicket);
      }
      const lastMessage =
        this.messages && this.messages.length
          ? this.messages[this.messages.length - 1]
          : null;
      if (lastMessage) {
        targets.push(lastMessage);
      }
      targets.forEach((target) => {
        this.$set(target, "executor_department", department || null);
        this.$set(target, "executor_department_id", nextId);
        this.$set(target, "executor_department_name", nextName);
      });
    },
    applyLocalExecutorUser(user) {
      const nextId = user && user.id != null ? user.id : null;
      const nextName = user && user.name ? user.name : null;
      const targets = [];
      if (this.selectedTicket) {
        targets.push(this.selectedTicket);
      }
      const lastMessage =
        this.messages && this.messages.length
          ? this.messages[this.messages.length - 1]
          : null;
      if (lastMessage) {
        targets.push(lastMessage);
      }
      targets.forEach((target) => {
        this.$set(target, "executor_user", user || null);
        this.$set(target, "executor_user_id", nextId);
        this.$set(target, "executor_user_name", nextName);
      });
    },
    changeTicketDepartment(department, ticketId) {
      if (this.syncingHeaderDepartment || !ticketId || this.isTicketClosed) {
        return;
      }
      const nextId =
        department && department.id != null ? Number(department.id) : null;
      const current = this.resolveExecutorDepartment(this.currentExecutorTicket());
      const currentId = current && current.id != null ? Number(current.id) : null;
      if (nextId === currentId) {
        return;
      }
      const previous = current;
      const currentUser =
        this.headerExecutorUser ||
        this.resolveExecutorUser(this.currentExecutorTicket());
      this.headerDepartment = department || null;
      this.applyLocalExecutorDepartment(department || null);
      this.$axios
        .put(this.$endpoint + "ticketing/1", {}, {
          params: this.buildExecutorParams(ticketId, department || null, currentUser),
        })
        .then(() => {
          this.$emit("ticketStatusChanged");
        })
        .catch((e) => {
          this.syncingHeaderDepartment = true;
          this.headerDepartment = previous;
          this.applyLocalExecutorDepartment(previous);
          this.$nextTick(() => {
            this.syncingHeaderDepartment = false;
          });
          this.$emit("ticketError", e);
        });
    },
    changeTicketExecutorUser(user, ticketId) {
      if (this.syncingHeaderExecutorUser || !ticketId || this.isTicketClosed) {
        return;
      }
      const nextId = user && user.id != null ? Number(user.id) : null;
      const current = this.resolveExecutorUser(this.currentExecutorTicket());
      const currentId = current && current.id != null ? Number(current.id) : null;
      if (nextId === currentId) {
        return;
      }
      const previous = current;
      const currentDepartment =
        this.headerDepartment ||
        this.resolveExecutorDepartment(this.currentExecutorTicket());
      this.headerExecutorUser = user || null;
      this.applyLocalExecutorUser(user || null);
      this.$axios
        .put(this.$endpoint + "ticketing/1", {}, {
          params: this.buildExecutorParams(
            ticketId,
            currentDepartment,
            user || null
          ),
        })
        .then(() => {
          this.$emit("ticketStatusChanged");
        })
        .catch((e) => {
          this.syncingHeaderExecutorUser = true;
          this.headerExecutorUser = previous;
          this.applyLocalExecutorUser(previous);
          this.$nextTick(() => {
            this.syncingHeaderExecutorUser = false;
          });
          this.$emit("ticketError", e);
        });
    },
    //ticketStatus
    toggleWaitingActionStatus(ticketId) {
      if (!ticketId || this.isTicketClosed || this.processing) return;
      this.changeTicketStatus(
        this.isWaitingAction ? "open" : "waiting_action",
        ticketId
      );
    },
    applyLocalTicketState(type) {
      const nextState =
        type === "closed"
          ? "close"
          : type === "waiting_action"
          ? "waiting_action"
          : "open";
      if (this.selectedTicket) {
        this.$set(this.selectedTicket, "state", nextState);
      }
      const lastMessage =
        this.messages && this.messages.length
          ? this.messages[this.messages.length - 1]
          : null;
      if (lastMessage) {
        this.$set(lastMessage, "state", nextState);
      }
    },
    changeTicketStatus(type, ticketId) {
      if (!ticketId || !type || this.isTicketClosed) return;

      const previousStatus = this.selectedTicketStatus;
      const params = {
        id: ticketId,
      };
      if (type === "closed") {
        params.closeTicket = "active";
      } else if (type === "open") {
        params.openTicket = "active";
      } else {
        params.actionTicket = "active";
      }

      this.processing = true;
      this.closingTicket = type === "closed";
      this.selectedTicketStatus = type;

      this.$axios
        .put(this.$endpoint + "ticketing/1", {}, { params })
        .then((r) => {
          this.processing = false;
          this.closingTicket = false;
          this.isTicketStateClosed = type === "closed" && r.status == 200;
          if (r.status == 200) {
            this.applyLocalTicketState(type);
          } else {
            this.selectedTicketStatus = previousStatus;
          }
          this.$emit("ticketStatusChanged");
        })
        .catch((e) => {
          this.processing = false;
          this.closingTicket = false;
          this.selectedTicketStatus = previousStatus;
          this.$emit("ticketError", e);
        });
    },
    fileAttach(value) {
      // value: {files}
      this.isFileAttached = true;
      this.$emit("fileAttach", value.files);
    },
    resolveDisplay() {
      if (
        (!this.isTicketSelected &&
          this.messages.length === 0 &&
          this.isCreateNewTicket) ||
        (!this.isTicketSelected && this.messages.length === 0 && this.createNewTicket) ||
        (this.isTicketSelected && this.messages.length > 0) ||
        (!this.isTicketSelected && this.messages.length > 0) ||
        (this.isTicketSelected && this.messages.length === 0)
      ) {
        return true;
      }
    },
    resolveWrapperHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return {
          height: "auto",
          minHeight: "50vh",
        };
      }
      return {
        height: "100%",
      };
    },
    createNewTicketHandler() {
      this.isTicketStateClosed = false;
      this.createNewTicket = true;
    },
    checkFormValidator() {
      if (!this.$refs.form.validate()) return false;
      if (this.$refs.form.validate()) {
        this.isFormValid = true;
      }
    },
    pauseTicket(ticketId) {
      if (
        ticketId == null &&
        !this.isTicketSelected &&
        this.messages.length === 0 &&
        (this.isCreateNewTicket || this.createNewTicket)
      ) {
        this.ticketTitle = null;
        this.department = null;
        this.isTicketCanceled = !this.isTicketCanceled;
        // reset form
        this.$refs.form.reset();
        this.isDialogVisible = false;
      } else {
        this.processing = true;
        this.closingTicket = true;
        var app = this;
        app.$axios
          .put(
            this.$endpoint + "ticketing/1",
            {},
            {
              params: {
                closeTicket: "active",
                id: ticketId,
              },
            }
          )
          .then((r) => {
            this.processing = false;
            this.closingTicket = false;
            if (r.status == 200) {
              this.isTicketStateClosed = true;
            } else {
              this.isTicketStateClosed = false;
            }
          })
          .catch((e) => {
            this.processing = false;
            this.closingTicket = false;
            this.$emit("ticketError", e);
          });
        this.isDialogVisible = false;
      }
    },
  },
  watch: {
    isCreateNewTicket(val) {
      if (val) {
        this.isTicketStateClosed = false;
        this.ticketTitle = null;
        this.department = null;
        this.selectedDepartmentId = null;
      }
    },
    department(val) {
      if (val) {
        this.selectedDepartmentId = val.id;
        this.$emit("onSelectedDepartment", this.selectedDepartmentId);
      }
    },
    selectedTicket: {
      immediate: true,
      handler(val) {
        if (val) {
          this.isTicketStateClosed = false;
          //ticketStatus
          const state = String(val.state || "").toLowerCase();
          if (state === "close" || state === "closed") {
            this.selectedTicketStatus = "closed";
          } else if (
            state === "waiting_action" ||
            state === "inprogress" ||
            state === "in_progress" ||
            state === "action"
          ) {
            this.selectedTicketStatus = "waiting_action";
          } else {
            this.selectedTicketStatus = "open";
          }
          this.selectedPriority = resolveTicketPriority(val.priority);
          this.syncingHeaderDepartment = true;
          this.syncingHeaderExecutorUser = true;
          this.headerDepartment = this.resolveExecutorDepartment(val);
          this.headerExecutorUser = this.resolveExecutorUser(val);
          this.$nextTick(() => {
            this.syncingHeaderDepartment = false;
            this.syncingHeaderExecutorUser = false;
          });
        }
      },
    },
    messages: {
      handler(val) {
        if (this.selectedTicket || !val || !val.length) {
          return;
        }
        const last = val[val.length - 1];
        this.syncingHeaderDepartment = true;
        this.syncingHeaderExecutorUser = true;
        this.headerDepartment = this.resolveExecutorDepartment(last);
        this.headerExecutorUser = this.resolveExecutorUser(last);
        this.$nextTick(() => {
          this.syncingHeaderDepartment = false;
          this.syncingHeaderExecutorUser = false;
        });
      },
    },
    stopLoading() {
      this.stop_loading = false;
    },
  },
};
</script>

<style scoped>
.wrapper-ticket-message {
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.wrapper-create-ticket {
  flex-shrink: 0;
  border: none;
  border-radius: 0;
  padding: 0;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}
.ticket-create-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 48px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 1;
}
.ticket-create-title {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 32px;
  color: #212121;
}
.ticket-create-cancel {
  flex: 0 0 auto;
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-color: red !important;
  color: red !important;
  min-width: 72px;
  height: 36px !important;
  max-height: 36px !important;
  border-radius: 4px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.ticket-create-fields {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 14px 16px;
  background: transparent;
  border-bottom: 1px solid #e6eaf0;
}
.ticket-create-field {
  flex: 1 1 0;
  min-width: 0;
  height: 36px;
}
.ticket-create-fields ::v-deep .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
  flex: 1 1 0;
}
.ticket-create-fields ::v-deep .v-input__control {
  min-height: 36px;
}
.ticket-create-fields ::v-deep .v-input__slot {
  min-height: 36px !important;
  height: 36px !important;
  margin-bottom: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
  border-radius: 4px !important;
}
.ticket-create-fields ::v-deep .v-text-field__details,
.ticket-create-fields ::v-deep .v-messages {
  display: none !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.ticket-create-fields ::v-deep .v-text-field--outlined fieldset {
  border: 1px solid #e6eaf0 !important;
  border-radius: 4px !important;
}
.ticket-create-fields ::v-deep .v-text-field--outlined:hover fieldset {
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.ticket-create-fields ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #0066ff !important;
}
.ticket-create-fields ::v-deep .v-text-field--outlined fieldset legend {
  width: 0 !important;
}
.ticket-create-fields ::v-deep .v-label {
  top: 8px !important;
  margin: 0 !important;
  font-size: 13px !important;
  line-height: 20px !important;
  color: #757575 !important;
}
.ticket-create-fields ::v-deep .v-label--active {
  display: none;
}
.ticket-create-fields ::v-deep input {
  font-size: 13px;
  max-height: 36px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  color: #424242 !important;
}
.ticket-create-fields ::v-deep input::placeholder {
  color: #757575 !important;
  opacity: 1 !important;
}
.ticket-create-fields ::v-deep .v-select__selections,
.ticket-create-fields ::v-deep .v-select__selection {
  color: #424242 !important;
  font-size: 13px !important;
}
.ticket-create-fields ::v-deep .v-icon {
  color: #757575 !important;
  font-size: 18px !important;
}
.ticket-create-fields ::v-deep .v-input--is-focused .v-icon {
  color: #0066ff !important;
}
.ticket-create-title-suffix {
  color: #9e9e9e;
  font-size: 12px;
  line-height: 32px;
  white-space: nowrap;
}
.theme--dark .wrapper-create-ticket {
  background: rgba(30, 30, 30, 0.78);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: none;
}
.theme--dark .ticket-create-header {
  background: rgba(30, 30, 30, 0.78);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .ticket-create-fields {
  background: transparent;
  border-bottom-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .ticket-create-fields ::v-deep .v-input__slot {
  background: #3a3a3a !important;
}
.theme--dark .ticket-create-fields ::v-deep .v-text-field--outlined fieldset {
  border-color: transparent !important;
}
.theme--dark .ticket-create-fields ::v-deep .v-text-field--outlined:hover fieldset {
  border-color: rgba(255, 255, 255, 0.16) !important;
}
.theme--dark .ticket-create-fields ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #56abfc !important;
}
.theme--dark .ticket-create-fields ::v-deep .v-label,
.theme--dark .ticket-create-fields ::v-deep input::placeholder {
  color: #bdbdbd !important;
}
.theme--dark .ticket-create-fields ::v-deep input,
.theme--dark .ticket-create-fields ::v-deep .v-select__selections,
.theme--dark .ticket-create-fields ::v-deep .v-select__selection {
  color: #eeeeee !important;
}
.theme--dark .ticket-create-fields ::v-deep .v-icon {
  color: #bdbdbd !important;
}
.theme--dark .ticket-create-title {
  color: #eeeeee;
}
.theme--dark .ticket-create-cancel {
  border-color: red !important;
  color: red !important;
  background: transparent !important;
}
@media (max-width: 959px) {
  .wrapper-create-ticket {
    width: 100%;
    padding: 0;
  }

  .ticket-create-header {
    padding: 12px;
  }

  .ticket-create-fields {
    margin: 0;
    padding: 12px 12px 14px;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .ticket-create-field,
  .ticket-create-fields ::v-deep .v-input {
    width: 100%;
    max-width: 100%;
    flex: none;
  }

  .ticket-create-cancel {
    width: 100%;
  }
}
.wrapper-ticket-message .wrapper-view,
.wrapper-ticket-message .wrapper-conversation {
  border: 0;
  border-radius: 0;
  position: relative;
  isolation: isolate;
  overflow: hidden;
  background-color: #f7f9fc;
}
.wrapper-ticket-message .wrapper-view {
  height: 100%;
}
.wrapper-ticket-message .wrapper-view::before,
.wrapper-ticket-message .wrapper-conversation::before {
  display: none;
  content: "";
  position: absolute;
  inset: -16px;
  background-image: url("../../../../../../assets/ticket/bg-ticket.png");
  background-repeat: repeat;
  background-size: 420px auto;
  filter: blur(0.4px);
  opacity: 0.35;
  z-index: -1;
  pointer-events: none;
}
.wrapper-ticket-message .wrapper-view::after,
.wrapper-ticket-message .wrapper-conversation::after {
  display: none;
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.55);
  z-index: -1;
  pointer-events: none;
}
.wrapper-ticket-message .wrapper-view .layer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.wrapper-ticket-message .wrapper-view .empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: max-content;
  max-width: 90%;
  gap: 12px;
}
.wrapper-ticket-message .wrapper-view .empty-state__img {
  display: block;
  width: 120px;
  height: auto;
  margin: 0 auto 4px;
}
.wrapper-ticket-message .wrapper-view .empty-state__title {
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  color: #0f172a;
}
.wrapper-ticket-message .wrapper-view .empty-state__subtitle {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: #7c7979;
}
.theme--dark .wrapper-ticket-message .wrapper-view .empty-state__title {
  color: #eeeeee;
}
.theme--dark .wrapper-ticket-message .wrapper-view .empty-state__subtitle {
  color: #9e9e9e;
}
.wrapper-ticket-message .wrapper-conversation {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.wrapper-ticket-message .wrapper-conversation .header {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-bottom: 1px solid #e6eaf0;
  background-color: #fff;
  border-radius: 0;
  height: auto;
  min-height: 0;
  flex-shrink: 0;
}
.ticket-header-bar {
  padding: 14px 16px !important;
}
.ticket-header-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;
}
.ticket-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.ticket-header-row .ticket-header-info {
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 12px;
}
.ticket-header-info {
  min-width: 0;
  width: 100%;
  margin-left: 0;
}
.ticket-header-title {
  margin: 0;
  font-size: 14.5px;
  font-weight: 800;
  line-height: 1.5;
  color: #0f172a;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.ticket-header-id {
  display: inline-block;
  white-space: nowrap;
  margin-inline-end: 8px;
  padding: 1px 6px;
  border-radius: 4px;
  background: #eef4ff;
  color: #0066ff;
  font-size: 12px;
  font-weight: 700;
  vertical-align: 2px;
}
.ticket-header-title-text {
  white-space: normal;
}
.ticket-header-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}
.ticket-header-status-btns {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}
.ticket-header-executor-fields {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}
.ticket-header-close-fallback {
  align-self: flex-start;
  flex: 0 0 auto;
}
.ticket-header-actions ::v-deep .ticket-priority-chip {
  height: 30px;
  font-size: 12px;
  padding: 0 8px 0 10px;
  border-radius: 4px;
  flex: 0 0 auto;
}
.ticket-header-actions .v-btn {
  border-radius: 4px !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  height: 30px !important;
  min-height: 30px !important;
  font-size: 11px !important;
  flex: 0 0 auto;
}
.ticket-header-department {
  width: 150px;
  min-width: 120px;
  max-width: 180px;
  height: 30px;
  flex: 0 1 150px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.ticket-header-department ::v-deep .v-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
  height: 30px !important;
  max-height: 30px !important;
}
.ticket-header-department ::v-deep .v-input__control {
  min-height: 30px !important;
  height: 30px !important;
}
.ticket-header-department ::v-deep .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  margin-bottom: 0 !important;
  background: #fff !important;
  box-shadow: none !important;
  border-radius: 4px !important;
}
.ticket-header-department ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
  padding: 0 8px !important;
}
.ticket-header-department ::v-deep .v-text-field--outlined fieldset {
  border: 1px solid #e6eaf0 !important;
  border-radius: 4px !important;
  top: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
}
.ticket-header-department ::v-deep .v-text-field--outlined:hover fieldset {
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.ticket-header-department ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #0066ff !important;
}
.ticket-header-department ::v-deep .v-text-field--outlined fieldset legend {
  width: 0 !important;
  display: none !important;
}
.ticket-header-department ::v-deep .v-text-field__details,
.ticket-header-department ::v-deep .v-messages {
  display: none !important;
  min-height: 0 !important;
  height: 0 !important;
}
.ticket-header-department ::v-deep .v-label {
  top: 5px !important;
  margin: 0 !important;
  font-size: 12px !important;
  line-height: 20px !important;
  color: #757575 !important;
  transform: none !important;
}
.ticket-header-department ::v-deep .v-label--active {
  display: none;
}
.ticket-header-department ::v-deep input,
.ticket-header-department ::v-deep .v-select__selections,
.ticket-header-department ::v-deep .v-select__selection {
  font-size: 12px;
  line-height: 30px;
  color: #424242 !important;
  max-height: 30px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: center;
}
.ticket-header-department ::v-deep input::placeholder {
  color: #757575 !important;
  opacity: 1 !important;
}
.ticket-header-department ::v-deep .v-icon {
  color: #757575 !important;
  font-size: 16px !important;
}
.ticket-header-department ::v-deep .v-input--is-focused .v-icon {
  color: #0066ff !important;
}
.ticket-header-department ::v-deep .v-select__slot,
.ticket-header-department ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
.ticket-header-actions > .d-flex {
  position: relative;
  z-index: 0;
}
.ticket-header-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  margin: 2px 0 0;
  font-size: 11.5px;
  line-height: 1.3;
}
.ticket-header-meta-piece {
  display: inline-flex;
  align-items: center;
}
.ticket-header-meta-dot {
  margin: 0 6px;
  font-size: 12px;
  line-height: 1;
  color: #cbd5e1;
}
.ticket-header-meta-item {
  color: #334155;
}
.ticket-header-meta-item.is-muted {
  color: #64748b;
}
.wrapper-ticket-message .wrapper-conversation .body {
  display: flex;
  align-items: end;
  flex-direction: column-reverse;
  padding: 8px 4px !important;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar {
  width: 4px;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar-thumb {
  background: #8888889f;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body::-webkit-scrollbar-thumb:hover {
  background: #555555cb;
  border-radius: 13px;
  margin-left: 5px;
}
.wrapper-ticket-message .wrapper-conversation .body .layer {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.wrapper-ticket-message .wrapper-conversation .body .layer .empty-ticket-title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: #424242;
}
.wrapper-ticket-message .wrapper-conversation .body .layer .empty-ticket-subtitle {
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: #7c7979;
}
.wrapper-ticket-message .wrapper-conversation .body .layer img {
  width: 460px;
  height: auto;
  min-height: 360px;
  max-width: 90%;
}
.wrapper-ticket-message .wrapper-conversation .footer {
  /* position: absolute;
    bottom: 0; */
  border-top: 1px solid #e6eaf0;
  background: #fff;
  flex-shrink: 0;
}
.wrapper-ticket-message .wrapper-relative-conversation {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.wrapper-ticket-message .wrapper-relative-conversation .wrapper-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(247, 249, 252, 0.7);
  height: 100%;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper-ticket-message .wrapper-relative-conversation .fade-enter-active,
.wrapper-ticket-message .wrapper-relative-conversation .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.wrapper-ticket-message .wrapper-relative-conversation .fade-enter,
.wrapper-ticket-message .wrapper-relative-conversation .fade-leave-to {
  opacity: 0;
}
/*dark mode */
.theme--dark .wrapper-ticket-message .wrapper-conversation,
.theme--dark .wrapper-ticket-message .wrapper-view {
  background: #181818;
}
.theme--dark .ticket-header-id {
  background: rgba(0, 102, 255, 0.18);
  color: #90caf9;
}
.theme--dark .wrapper-create-ticket {
  background: #1e1e1e;
}
.theme--dark .wrapper-ticket-message .wrapper-view::before,
.theme--dark .wrapper-ticket-message .wrapper-conversation::before,
.theme--dark .wrapper-ticket-message .wrapper-view::after,
.theme--dark .wrapper-ticket-message .wrapper-conversation::after {
  display: none;
}

.theme--dark .wrapper-ticket-message .wrapper-conversation .header {
  background-color: #1e1e1e;
  border-bottom-color: #444;
}
.theme--dark .ticket-header-title {
  color: #fff;
}
.theme--dark .ticket-header-meta-item {
  color: #eeeeee;
}
.theme--dark .ticket-header-meta-item.is-muted {
  color: #9e9e9e;
}
.theme--dark .ticket-header-meta-dot {
  color: #9e9e9e;
}
.theme--dark .ticket-header-department ::v-deep .v-input__slot {
  background: #3a3a3a !important;
}
.theme--dark .ticket-header-department ::v-deep .v-text-field--outlined fieldset {
  border-color: transparent !important;
}
.theme--dark .ticket-header-department ::v-deep .v-text-field--outlined:hover fieldset {
  border-color: rgba(255, 255, 255, 0.16) !important;
}
.theme--dark .ticket-header-department ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #56abfc !important;
}
.theme--dark .ticket-header-department ::v-deep .v-label,
.theme--dark .ticket-header-department ::v-deep input::placeholder,
.theme--dark .ticket-header-department ::v-deep .v-icon {
  color: #bdbdbd !important;
}
.theme--dark .ticket-header-department ::v-deep input,
.theme--dark .ticket-header-department ::v-deep .v-select__selections,
.theme--dark .ticket-header-department ::v-deep .v-select__selection {
  color: #eeeeee !important;
}

.theme--dark .wrapper-ticket-message .wrapper-conversation .footer {
  background: rgba(30, 30, 30, 0.78);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top-color: rgba(255, 255, 255, 0.08);
}

.theme--dark
  .wrapper-ticket-message
  .wrapper-conversation
  .body::-webkit-scrollbar-track {
  background: #2a2a2a;
}

.theme--dark .wrapper-ticket-message .wrapper-relative-conversation .wrapper-loading {
  background-color: rgba(0, 0, 0, 0.45);
}
@media (max-width: 959px) {
  .wrapper-ticket-message {
    height: 100%;
  }
  .wrapper-ticket-message .wrapper-view {
    height: 100%;
    min-height: 0;
  }
  .wrapper-ticket-message .wrapper-conversation {
    height: 100% !important;
    min-height: 0 !important;
  }
  .wrapper-ticket-message .wrapper-conversation .body {
    flex: 1 1 auto;
    min-height: 0;
  }
  .ticket-header-bar {
    padding: 10px 12px !important;
  }
  .ticket-header-status-btns,
  .ticket-header-executor-fields {
    flex: 1 1 100%;
    flex-wrap: wrap;
  }
  .ticket-header-department {
    flex: 1 1 0;
    max-width: none;
  }
  .wrapper-ticket-message .wrapper-conversation .header {
    height: auto;
    min-height: 0;
  }
}
</style>
